import { HeaderAndTableCellDraft, TableDraft } from '@markant-platform/shared/table/model';

import { BookingStateMap } from '@markant-platform/shared/cartridge/model';
import { Filter } from '@markant-platform/shared/ui-filter';
import { UsageRightActivationState } from '@markant-platform/usage-right/model';
import { CartridgeOverviewInfo } from '@markant-platform/shared/organization/model';
import { RoleConfig, StaticRole } from '@markant-platform/shared/user/model';

const COMMON_TABLE_CELLS: HeaderAndTableCellDraft[] = [
  {
    headerCellColumnId: 'cartridgeName',
    headerCellTranslationKey: 'dashboard.cartridge.overviewTable.col.name',
    tableCellContentType: 'STRING',
    tableCellContentKey: 'name',
  },
  {
    headerCellColumnId: 'bookingState',
    headerCellTranslationKey: 'dashboard.cartridge.overviewTable.col.status',
    tableCellContentType: 'CHIP_AND_STRING',
    tableCellContentKey: 'validityEndText',
    additionalChip: {
      displayCondition: (obj: unknown): boolean => {
        return !(obj as CartridgeOverviewInfo).validityEndText;
      },
      tableCellContentKey: 'usageRightActivationState',
      tableCellTranslationPrefix: 'usageRight.activationState',
      chipConfigMap: BookingStateMap,
    },
  },
  {
    headerCellColumnId: 'serviceManager',
    headerCellTranslationKey: 'dashboard.cartridge.overviewTable.col.serviceManager',
    tableCellContentType: 'STRING',
    tableCellContentKey: 'serviceManager',
  },
];

export const PA_ORGANIZATION_BOOKINGS_TABLE: TableDraft = {
  sortColumnIds: ['cartridgeName', 'bookingState', 'bookingStartedAt', 'cancellationDate'],
  sortStartColumnId: 'bookingStartedAt',
  sortStartDirection: 'desc',
  headerAndTableCells: [
    ...COMMON_TABLE_CELLS,
    {
      headerCellColumnId: 'bookingStartedAt',
      headerCellTranslationKey: 'dashboard.cartridge.overviewTable.col.validFrom',
      tableCellContentType: 'DATE',
      tableCellContentKey: 'bookingStartedAt',
    },
    {
      headerCellColumnId: 'cancellationDate',
      headerCellTranslationKey: 'dashboard.cartridge.overviewTable.col.validUntil',
      tableCellContentType: 'DATE',
      tableCellContentKey: 'validityPeriodEnd',
    },
  ],
};

export const OA_ORGANIZATION_BOOKINGS_TABLE: TableDraft = {
  sortColumnIds: [
    'cartridgeName',
    'bookingState',
    'bookingDate',
    'workflowFinishedAt',
    'bookingStartedAt',
    'cancellationDate',
  ],
  sortStartColumnId: 'bookingDate',
  sortStartDirection: 'desc',
  headerAndTableCells: [
    ...COMMON_TABLE_CELLS,
    {
      headerCellColumnId: 'bookingDate',
      headerCellTranslationKey: 'dashboard.cartridge.overviewTable.col.bookingDate',
      tableCellContentType: 'DATE',
      tableCellContentKey: 'bookingDate',
    },
    {
      headerCellColumnId: 'workflowFinishedAt',
      headerCellTranslationKey: 'dashboard.cartridge.overviewTable.col.workflowFinishedAt',
      tableCellContentType: 'DATE',
      tableCellContentKey: 'workflowFinishedAt',
    },
    {
      headerCellColumnId: 'bookingStartedAt',
      headerCellTranslationKey: 'dashboard.cartridge.overviewTable.col.bookingStartedAt',
      tableCellContentType: 'DATE',
      tableCellContentKey: 'bookingStartedAt',
    },
    {
      headerCellColumnId: 'cancellationDate',
      headerCellTranslationKey: 'dashboard.cartridge.overviewTable.col.validityPeriodEnd',
      tableCellContentType: 'DATE',
      tableCellContentKey: 'validityPeriodEnd',
    },
  ],
};

export const ORGANIZATION_BOOKINGS_FILTER: Filter = {
  state: {
    groupName: 'stateFilter',
    translationKey: 'usageRight.state',
    filterOptions: Object.keys(UsageRightActivationState).map(res => ({
      key: res,
      label: `usageRight.activationState.${res}`,
      isTranslationKey: true,
    })),
  },
};

export const ROLE_CONFIG: RoleConfig[] = [
  {
    role: StaticRole.PLATFORM_ADMIN,
    routeIdentifier: /^\/backoffice\/organizations\/[a-z0-9-]+\/services/,
    additionalConfig: {
      headline: ['cartridge.bookings.overview.headline.services'],
    },
  },
  {
    role: StaticRole.ORGANIZATION_ADMIN,
    routeIdentifier: /^\/(organization|backoffice)\/organization-overview\/services/,
    additionalConfig: {
      headline: ['cartridge.bookings.overview.headline.services'],
    },
  },
  {
    role: StaticRole.ORGANIZATION_ADMIN,
    routeIdentifier: /^\/(organization|backoffice)\/booked-cartridges/,
    additionalConfig: {
      headline: ['cartridge.bookings.overview.headline.myServices'],
    },
  },
];
